const rules = {
    claim_id: [
        v => !!v || 'Claim ID is required',
        v => (v && v.length <= 21) || 'Claim ID must be 21 characters',
    ],

    transmittal_id: [
        v => !!v || 'Transmittal ID is required',
        v => (v && v.length <= 21) || 'Transmittal ID must be 21 characters',
    ],

    pin: [
        v => !!v || 'PIN is required',
        v => (v && v.length === 12) || 'PIN must be 12 characters',
    ],
};

export default rules;